import { useProfileAgreement } from '@/hooks/queries/use-profile-agreement';
import { useProfileClientCategorisationTreatment } from '@/hooks/queries/use-profile-client-categorisation-treatment';
import { useProfileFuturesAppropriateness } from '@/hooks/queries/use-profile-futures-appropriateness';
import { useProfileInstitutionDetailsMeta, useProfileInstitutionDetailsV2Answers } from '@/hooks/queries/use-profile-institution-details';
import { AgreementKey } from '@/services/api/profile/agreement';

/**
 * The first futures step left for a V2 application that selected futures, which follow the authorisation.
 * Undefined once they are done, and for V1 records, which complete them after onboarding instead.
 */
export const useInstitutionOnboardingFuturesNext = () => {
  const { isLoading: isLoadingInstitutionDetailsAnswers, data: institutionDetailsAnswers } = useProfileInstitutionDetailsV2Answers();
  const {
    isLoading: isLoadingInstitutionDetailsMeta,
    data: { isRegulated },
  } = useProfileInstitutionDetailsMeta();
  const { isLoading: isLoadingServicesAgreement, data: servicesAgreement } = useProfileAgreement(AgreementKey.SERVICES_AGREEMENT);
  const { isLoading: isLoadingClientCategorisationTreatment, data: clientCategorisationTreatment } = useProfileClientCategorisationTreatment();
  const { isLoading: isLoadingFuturesAppropriateness, data: futuresAppropriateness } = useProfileFuturesAppropriateness();
  const isLoading =
    isLoadingInstitutionDetailsAnswers ||
    isLoadingInstitutionDetailsMeta ||
    isLoadingServicesAgreement ||
    isLoadingClientCategorisationTreatment ||
    isLoadingFuturesAppropriateness;

  const getRoute = () => {
    if (institutionDetailsAnswers?.products?.futures !== 'YES') return undefined;

    if (!servicesAgreement?.date) return '/institution/onboarding/futures/services-agreement';

    if (!clientCategorisationTreatment) return '/institution/onboarding/futures/client-categorisation/treatment';

    // Regulated institutions don't take the appropriateness test
    if (!isRegulated && !(futuresAppropriateness && 'result' in futuresAppropriateness)) return '/institution/onboarding/futures/appropriateness-test';

    return undefined;
  };

  return { isLoading, route: isLoading ? undefined : getRoute() };
};
